import ExecutionType from '../model/execution';
import AxiosInstance from '../api/http-config';

const EXECUTION_LIST_PATH = '/executions';

export let fetchExecutions = async (): Promise<ExecutionType[] | null> => {
  try {
    return await AxiosInstance.get(EXECUTION_LIST_PATH, {
      baseURL: 'http://localhost:4000'
    }).then(response => {
      return response.data.executions;
    });
  } catch (err) {
    console.log(err);
    return null;
  }
};
